export default __webpack_public_path__ + "static/MediaContentEight-a24d55c17223120ca4f3450b3821512e.webp";